import * as React from 'react'; 

import { useDispatch } from 'react-redux';
import { setIsPickup } from '../actions/cartActions';
import PropTypes from 'prop-types';

import styles from './CategorySearchResults.module.css';

const NotAvailableMessage = ({categoryName, zipCode, isPickup}) => {
  
  const dispatch = useDispatch();
  
  // format + handle null
  const displayName = categoryName ? categoryName.toLowerCase() : '';

  return (
    <div className={styles.noProductsMsg}>
      { isPickup 
        ? <>
            Sorry, there are currently no <b>{displayName}</b> products available for pickup.
          </>
        : <>
            Sorry, we're not currently delivering <b>{displayName}</b>
            { zipCode &&
              <> 
               {' '}to {zipCode}
              </>
            }. 
            <div>
              To browse {displayName} products, switch to  
              {' '}<span className={styles.noProductsLink} onClick={() => dispatch(setIsPickup(true))}>In-Store Pickup</span>.   
            </div>
          </>
      }
    </div>
  );
};

NotAvailableMessage.propTypes = {
  categoryName: PropTypes.string.isRequired,
  zipCode: PropTypes.any,
  isPickup: PropTypes.bool.isRequired
}

export default NotAvailableMessage
